<!--Navigation Bar-->
<app-navbar>
    <h2>Editeaza Job</h2>
</app-navbar>

<!--Job Form-->
<div class="post-job-area">
    <div class="container">
        <div class="post-job-item padding-0 border-0">

            <!-- Account Sign In -->
            <app-check-current-user></app-check-current-user>

            <app-form-message [success]="formResponse" *ngIf="formSent"></app-form-message>


            <!--Form Start-->
            <form (ngSubmit)="onUpdateJob(jobForm)" #jobForm='ngForm' id="post-job-form">

                <div *ngIf="isLoaded">
                    <!--Job Details-->
                    <div id="details-job">
                        <div class="row">
                            <div class="col-12">
                                <h5 class="custom-section-title">Detalii Job</h5>
                            </div>
                            <div class="col-12">
                                <div class="bg-white p-5">
                                    <div class="row">

                                        <!--Job Title-->
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label class="m-0" for="jobTitle">Denumire</label>
                                                <input id="jobTitle"
                                                        type="text"
                                                        class="form-control"
                                                        [(ngModel)]="jobAllData.jobTitle"
                                                        name="jobTitle"
                                                        #jobTitle='ngModel'
                                                        required>
                                                <div class="error-msg" *ngIf="!jobTitle.valid && (jobTitle.touched || jobForm.submitted)">Acest
                                                    camp este obligatoriu!
                                                </div>
                                            </div>
                                        </div>
                                        <!--End Date-->
                                        <!-- <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label class="m-0" >Data Expirare</label>
                                                <p>{{jobAllData.jobEndingDate}}</p>
                                            </div>
                                        </div> -->
                                        <!--Photo-->
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label class="m-0" for="photo">Poza reprezentativa</label>
                                                <input
                                                        type="file"
                                                        id="photo"
                                                        class="form-control"
                                                        ngModel
                                                        name="photo"
                                                        (change)="selectFile($event)"
                                                        #photo="ngModel"
                                                >
                                            </div>
                                        </div>
                                        <!--Video Link-->
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label class="m-0" for="videoLink">Link video</label>
                                                <input
                                                        type="text"
                                                        id="videoLink"
                                                        class="form-control"
                                                        [(ngModel)]="jobAllData.videoLink"
                                                        name="videoLink"
                                                        placeholder="Video URL"
                                                        #videoLink="ngModel"
                                                >
                                            </div>
                                        </div>
                                        <!--Ideal Candidate-->
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label class="m-0" for="idealCandidate">Candidatul ideal</label>
                                                <!-- <textarea
                                                        id="idealCandidate"
                                                        class="form-control"
                                                        rows="10"
                                                        [(ngModel)]="jobAllData.idealCandidate"
                                                        name="idealCandidate"

                                                        minlength="10"
                                                        #idealCandidate='ngModel'
                                                >
                                                </textarea> -->
                                                <angular-editor [(ngModel)]="jobAllData.idealCandidate"
                                            name="idealCandidate"
                                            id="idealCandidate"
                                            [config]="editorConfig"
                                            #idealCandidate='ngModel'
                                            ngModel
                                            required>
                                            </angular-editor>
                                            <div class="error-msg" *ngIf="!idealCandidate.valid && (idealCandidate.touched || jobForm.submitted)">Acest
                                                camp este obligatoriu!
                                            </div>

                                            </div>
                                        </div>
                                        <!--Job Description-->
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label class="m-0" for="jobDescription">Descrierea jobului</label>
                                                <!-- <textarea
                                                        id="jobDescription"
                                                        class="form-control"
                                                        rows="10"
                                                        [(ngModel)]="jobAllData.jobDescription"
                                                        name="jobDescription"
                                                        minlength="10"
                                                        #jobDescription="ngModel"
                                                        required>
                                                </textarea> -->
                                                <angular-editor [(ngModel)]="jobAllData.jobDescription"
                                            name="jobDescription"
                                            id="jobDescription"
                                            [config]="editorConfig"
                                            #jobDescription='ngModel'
                                            required>
                                                </angular-editor>
                                                <div class="error-msg" *ngIf="!jobDescription.valid && (jobDescription.touched || jobForm.submitted)">Acest
                                                    camp este obligatoriu!
                                                </div>

                                            </div>
                                        </div>
                                        <!--Benefits-->
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label class="m-0" for="benefits">Beneficii</label>
                                                <!-- <textarea
                                                        id="benefits"
                                                        class="form-control"
                                                        rows="10"
                                                        [(ngModel)]="jobAllData.benefits"
                                                        name="benefits"

                                                        minlength="10"
                                                        #benefits="ngModel"
                                                >
                                            </textarea> -->
                                            <angular-editor [(ngModel)]="jobAllData.benefits"
                                            name="benefits"
                                            id="benefits"
                                                                                       
                                            [config]="editorConfig"
                                            #benefits='ngModel'
                                            >
                                            </angular-editor>
                                            </div>
                                        </div>
                                        <!--Country-->
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label for="country" class="m-0">Tara</label>
                                                <ng-select2 [data]="locationsArrayValues"
                                                            [options]="singleOption"
                                                            id="country"
                                                            [(ngModel)]="jobAllData.country"
                                                            name="country"
                                                            (valueChanged)="changeCountry($event)"
                                                            #country="ngModel">
                                                </ng-select2>
                                                <div class="error-msg" *ngIf="!country.valid && (country.touched || jobForm.submitted)">Acest
                                                    camp este obligatoriu!
                                                </div>
                                            </div>
                                        </div>
                                        <!--City-->
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label for="city" class="m-0">Oras</label>
                                                <ng-select2 [data]="city"
                                                            [options]="multiOptions"
                                                            id="city"
                                                            [(ngModel)]="jobAllData.city"
                                                            name="city"
                                                            required
                                                            #jobCity="ngModel">
                                                </ng-select2>
                                                <div class="error-msg" *ngIf="!jobCity.valid && (jobCity.touched || jobForm.submitted)">Acest
                                                    camp este obligatoriu!
                                                </div>
                                            </div>
                                        </div>
                                        <!--Relocation Possibility-->
                                        <div class="col-lg-6 col-12">
                                            <div class="form-group">
                                                <div class="job-type-area">
                                                    <label for="relocationPossibility" class="d-block c-label">Posibilitate
                                                        relocare</label>
                                                    <label for="relocationPossibility"
                                                           class="checkbox-container d-inline-block">Da
                                                        <input class="form-check-input"
                                                               type="checkbox"
                                                               id="relocationPossibility"
                                                               name="relocationPossibility"
                                                               [(ngModel)]="jobAllData.relocationPossibility"
                                                        >
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <!--Relocation Facility-->
                                        <div class="col-lg-6 col-12">
                                            <div class="form-group">
                                                <div class="job-type-area">
                                                    <label for="relocationPackageIncluded" class="d-block c-label">Facilitati
                                                        relocare</label>
                                                    <label for="relocationPackageIncluded"
                                                           class="checkbox-container d-inline-block">Da
                                                        <input class="form-check-input"
                                                               type="checkbox"
                                                               id="relocationPackageIncluded"
                                                               name="relocationPackageIncluded"
                                                               [(ngModel)]="jobAllData.relocationPackageIncluded"
                                                        >
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <!--Open Position-->
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label class="m-0" for="openPositions">Numar joburi disponibile</label>
                                                <div class="input-group">
                                                    <input class="form-control" type="number" id="openPositions"
                                                           name="openPositions" [(ngModel)]="jobAllData.openPositions">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text currency-box">Joburi</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!--Work Type-->
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label class="m-0" for="workType">Tip job</label>
                                                <ng-select2 
                                                [(ngModel)]="jobAllData.workType"
                                                [data]="jobType"
                                                [options]="multiOptions"
                                                name="workType"
                                                #workType="ngModel"
                                                required>
                                                
                                                </ng-select2>

                                                <div class="error-msg" *ngIf="!workType.valid && (workType.touched || jobForm.submitted)">Acest
                                                    camp este obligatoriu!
                                                </div>
                                                <!-- <select
                                                        id="workType"
                                                        class="form-control"
                                                        [(ngModel)]="jobAllData.workType"
                                                        name="workType"
                                                        required
                                                        #workType='ngModel'
                                                >
                                                    <option value="" selected disabled hidden> -- Selecteaza optiune --
                                                    </option>
                                                    <option value="volunteer" selected>Voluntariat</option>
                                                    <option value="practice">Practica</option>
                                                    <option value="project">Proiect</option>
                                                    <option value="temporary">Temporar</option>
                                                    <option value="part_time">Part-Time</option>
                                                    <option value="full_time">Full-Time</option>
                                                    <option value="remote">La Distanta(Remote)</option>
                                                    <option value="internship">Internship</option>

                                                </select> -->
                                                <!-- <div class="error-msg" *ngIf="!workType.valid && (workType.touched || jobForm.submitted)">Acest
                                                    camp este obligatoriu!
                                                </div> -->

                                            </div>
                                        </div>
                                        <!--Contract Type-->
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label class="m-0" for="contractType">Tip contract</label>
                                                <select
                                                        id="contractType"
                                                        class="form-control"
                                                        [(ngModel)]="jobAllData.contractType"
                                                        name="contractType"
                                                        required
                                                        #contractType='ngModel'
                                                >
                                                    <option value="" selected disabled hidden> -- Selecteaza optiune --
                                                    </option>
                                                    <option value="employment" selected>Angajare</option>
                                                    <option value="contractor">Contractor (Pers. Juridica)</option>

                                                </select>
                                                <div class="error-msg" *ngIf="!contractType.valid && (contractType.touched || jobForm.submitted)">Acest
                                                    camp este obligatoriu!
                                                </div>
                                            </div>
                                        </div>
                                        <!--Experience Level-->
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label class="m-0" for="experienceLevel">Nivel</label>
                                                <select
                                                        id="experienceLevel"
                                                        class="form-control"
                                                        [(ngModel)]="jobAllData.experienceLevel"
                                                        name="experienceLevel"

                                                        #experienceLevel='ngModel'
                                                >
                                                    <option value="" selected disabled hidden> -- Selecteaza optiune --
                                                    </option>
                                                    <option value="student" selected>Student</option>
                                                    <option value="entry_level">Proaspat Absolvent</option>
                                                    <option value="junior">Junior</option>
                                                    <option value="specialist">Specialist</option>
                                                    <option value="senior">Senior</option>
                                                    <option value="executive">Top Manager/Executiv</option>

                                                </select>

                                            </div>
                                        </div>
                                        <!--Job Disponibility-->
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label class="m-0" for="jobDisponibility">Disponibilitate job</label>
                                                <select
                                                        id="jobDisponibility"
                                                        class="form-control"
                                                        [(ngModel)]="jobAllData.jobDisponibility"
                                                        name="jobDisponibility"

                                                        #jobDisponibility='ngModel'
                                                >
                                                    <option value="" selected disabled hidden> -- Selecteaza optiune --
                                                    </option>
                                                    <option value="immediate" selected>Imediat</option>
                                                    <option value="in_30_days">30 Zile</option>
                                                    <option value="in_90_days">90 Zile</option>
                                                    <option value="in_6_months">6 Luni</option>
                                                    <option value="in_9_months">9 Luni</option>
                                                    <option value="in_12_months">12 Luni</option>

                                                </select>


                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="row">
                                                <div class="col-md-4 form-group" *ngIf="Domains">
                                                    <label>Domeniu</label>
                                                    <select [(ngModel)]="selectedDomain"
                                                            (change)="changeDomain($event)"
                                                            class="form-control"
                                                            name="activitySector"
                                                            required
                                                            #domainController="ngModel">
                                                        <option *ngFor="let country of Domains">{{country.name}}</option>
                                                    </select>
                                                    <div class="error-msg"
                                                         *ngIf="!domainController.valid && (domainController.touched || jobForm.submitted)">
                                                        Acest
                                                        camp este obligatoriu!
                                                    </div>
                                                </div>
                                                <div class="col-md-4 form-group" *ngIf="subDomainsArray">
                                                    <label>Subdomenii</label>
                                                    <ng-select2
                                                            [(ngModel)]="selectedSubdomains"
                                                            [data]="subDomainsArray"
                                                            [options]="singleOption"
                                                            (valueChanged)="changeSubDomain($event)"
                                                            name="activitySubSector"
                                                            required
                                                            #subdomainController="ngModel"
                                                    >
                                                    </ng-select2>
                                                    <div class="error-msg" *ngIf="!subdomainController.valid && (subdomainController.touched || jobForm.submitted)">
                                                        Acest
                                                        camp este obligatoriu!
                                                    </div>
                                                </div>
                                                <div class="col-md-4 form-group"
                                                     *ngIf="selectedSubdomains && categoriesArray.length > 0">
                                                    <label>Categorii</label>
                                                    <ng-select2
                                                            [(ngModel)]="selectedCategories"
                                                            [data]="categoriesArray"
                                                            [options]="singleOption"
                                                            name="category"
                                                            required
                                                            #categoriesController="ngModel"
                                                    >
                                                    </ng-select2>
                                                    <div class="error-msg" *ngIf="!categoriesController.valid && (categoriesController.touched || jobForm.submitted)">
                                                        Acest
                                                        camp este obligatoriu!
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
<!--                                        &lt;!&ndash;Job Domain&ndash;&gt;-->
<!--                                        <div class="col-md-6 col-12">-->
<!--                                            <div class="form-group">-->
<!--                                                <label for="activitySector" class="mb-0">Domeniu</label>-->
<!--                                                <ng-select2 [data]="domainsArrayValues"-->
<!--                                                            [options]="singleOption"-->
<!--                                                            id="activitySector"-->
<!--                                                            [(ngModel)]="jobAllData.activitySector"-->
<!--                                                            name="activitySector"-->
<!--                                                            (valueChanged)="changeDomain($event)">-->
<!--                                                </ng-select2>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        &lt;!&ndash;Job Subdomain&ndash;&gt;-->
<!--                                        <div class="col-md-6 col-12">-->
<!--                                            <div class="form-group">-->
<!--                                                <label for="activitySubSector" class="mb-0">Subdomeniu</label>-->
<!--                                                <ng-select2 [data]="subdomains"-->
<!--                                                            [options]="singleOption"-->
<!--                                                            ngModel-->
<!--                                                            id="activitySubSector"-->
<!--                                                            [(ngModel)]="jobAllData.activitySubSector"-->
<!--                                                            name="activitySubSector">-->
<!--                                                </ng-select2>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        &lt;!&ndash;Category&ndash;&gt;-->
<!--                                        <div class="col-md-6 col-12">-->
<!--                                            <div class="form-group">-->
<!--                                                <label class="m-0" for="category">Categorie</label>-->
<!--                                                <ng-select2 [data]="selectCategory"-->
<!--                                                            [options]="singleOption"-->
<!--                                                            [(ngModel)]="jobAllData.category"-->
<!--                                                            id="category"-->
<!--                                                            name="category"-->
<!--                                                            #category="ngModel">-->
<!--                                                </ng-select2>-->
<!--                                            </div>-->
<!--                                        </div>-->
                                        <!--Department-->
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label class="m-0" for="department">Departament</label>
                                                <ng-select2 [data]="departments"
                                                            [options]="multiOptions"
                                                            [(ngModel)]="jobAllData.department"
                                                            id="department"
                                                            name="department"
                                                            #department="ngModel">
                                                </ng-select2>
                                            </div>
                                        </div>
                                        <!--Department Coordinator-->
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label class="m-0" for="departmentCoordinator">Coordonator de
                                                    departament(OPTIONAL)</label>
                                                <input
                                                        id="departmentCoordinator"
                                                        type="text"
                                                        class="form-control"
                                                        placeholder="Nume, Pozitia(Ex: DIR GEN, SEF DEP, ETC) + Mesaj"
                                                        name="departmentCoordinator"
                                                        [(ngModel)]="jobAllData.departmentCoordinator"
                                                        #departmentCoordinator="ngModel"

                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Studies Requirements-->
                    <div id="studies-requirements" class="mt-10">
                        <div class="row">
                            <div class="col-12">
                                <h5 class="custom-section-title">Studii necesare</h5>
                            </div>
                            <div class="col-12">
                                <div class="bg-white p-5">
                                    <div class="row">
                                        <!--Studies-->
                                        <div class="col-md-12 col-12">
                                            <div class="form-group mb-0">
                                                <label class="m-0" for="studies">Cunostinte - Studii</label>
                                                <select
                                                        id="studies"
                                                        class="form-control"
                                                        name="studies"
                                                        [(ngModel)]="jobAllData.studies"
                                                        #studies="ngModel"
                                                >
                                                    <option value="" selected disabled hidden> -- Selecteaza
                                                        optiune --
                                                    </option>
                                                    <option *ngFor="let studies of selectStudies"
                                                            value="{{studies.valueName}}">{{studies.name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--Other Courses-->
                                        <div class="col-md-12 col-12">
                                            <div class="form-group">
                                                <label class="m-0" for="otherCourses">Alte cursuri/formari</label>
                                                <!-- <textarea type="text"
                                                       class="form-control"
                                                       id="otherCourses"
                                                       name="otherCourses"
                                                          rows="4"
                                                       [(ngModel)]="jobAllData.otherCourses"
                                                       #otherCourses='ngModel'
                                                ></textarea> -->
                                                <angular-editor [(ngModel)]="jobAllData.otherCourses"
                                                name="otherCourses"
                                                id="otherCourses"
                                                
                                                [config]="editorConfig"
                                                #otherCourses='ngModel'
                                                >
                                                </angular-editor>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Required Skills-->
                    <div id="required-skills" class="mt-10">
                        <div class="row">
                            <div class="col-12">
                                <h5 class="custom-section-title">Alte cunostinte necesare</h5>
                            </div>
                            <div class="col-12">
                                <div class="bg-white p-5">
                                    <div class="row">
                                        <!--Foreign Languages-->
                                        <div class="col-md-12">
                                            <ng-template ngFor let-userLanguages [ngForOf]="form.userLanguages"
                                                         let-index="index" ngModelGroup="foreignLanguage">
                                                <div class="userLanguages mb-5">
                                                    <div class="row" ngModelGroup="foreignLanguage_{{index}}">
                                                        <div class="col-md-9 col-6">
                                                            <div class="form-group mb-0">
                                                                <label class="m-0" for="foreignLanguage">Limba</label>
                                                                <select id="foreignLanguage"
                                                                        name="language"
                                                                        [(ngModel)]="userLanguages.language"
                                                                        class="form-control">
                                                                    <option value="" selected disabled hidden> --
                                                                        Selecteaza
                                                                        optiune --
                                                                    </option>
                                                                    <option *ngFor="let lang of languages"
                                                                            value="{{lang}}">{{lang}}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2 col-6">
                                                            <div class="form-group mb-0">
                                                                <label class="m-0"
                                                                       for="foreignLanguageLevel">Nivel</label>
                                                                <select id="foreignLanguageLevel"
                                                                        name="level"
                                                                        [(ngModel)]="userLanguages.level"
                                                                        class="form-control">
                                                                    <option value="" selected disabled hidden> --
                                                                        Selecteaza
                                                                        optiune --
                                                                    </option>
                                                                    <option value="Incepator">Incepator</option>
                                                                    <option value="Mediu">Mediu</option>
                                                                    <option value="Avansat">Avansat</option>
                                                                    <option value="Nativ">Nativ</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-1 col-12 mt-9">
                                                            <button (click)="removeUserLanguages( index )"
                                                                    title="Remove Language"
                                                                    class="remove btn btn-danger">
                                                                X
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-template>
                                            <p class="actions">
                                                <button class="form-control add-language" type="button"
                                                        (click)="addUserLanguages()">
                                                        Mai adaugă o limbă
                                                </button>
                                            </p>
                                        </div>
                                        <!--Pc Knowledge-->
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label class="m-0" for="pcKnowledge">Cunostinte PC</label>
                                                <input type="text"
                                                       class="form-control"
                                                       id="pcKnowledge"
                                                       name="pcKnowledge"
                                                       [(ngModel)]="jobAllData.pcKnowledge"
                                                       placeholder="Software Specific, Hardware"

                                                       #pcKnowledge="ngModel"
                                                >
                                            </div>
                                        </div>
                                        <!--Driver License-->
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label class="m-0" for="driverLicense">Permis de conducere</label>

                                                <ng-select2
                                                        [data]="driveLicense"
                                                        [options]="multiOptions"
                                                        [placeholder]="'-- Selecteaza optiune --'"
                                                        [(ngModel)]="jobAllData.driverLicense"
                                                        id="driverLicense"
                                                        name="driverLicense"
                                                        #driverLicense="ngModel">
                                                </ng-select2>
                                            </div>

                                        </div>
                                        <!--Availability for Traveling-->
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label class="m-0" for="availableForTraveling">Disponibilitate la
                                                    deplasare</label>
                                                <select
                                                        id="availableForTraveling"
                                                        class="form-control"
                                                        [(ngModel)]="jobAllData.availableForTraveling"
                                                        name="availableForTraveling"

                                                        #availableForTraveling='ngModel'
                                                >
                                                    <option value="" selected disabled hidden> -- Selecteaza optiune --
                                                    </option>
                                                    <option value="10%">10%</option>
                                                    <option value="25%">25%</option>
                                                    <option value="50%">50%</option>
                                                    <option value="75%">75%</option>
                                                    <option value="100%">100%</option>
                                                    <option value="Altele">Altele</option>

                                                </select>
                                            </div>
                                        </div>
                                        <!--Job Abilities-->
                                        <div class="col-md-12">
                                            <ng-template ngFor let-jobAbilities [ngForOf]="form.jobAbilities"
                                                         let-index="index" ngModelGroup="jobAbilities">
                                                <div class="jobAbilities mb-5">
                                                    <div class="row" ngModelGroup="abilityName{{index}}">
                                                        <div class="col-md-4 col-6">
                                                            <div class="form-group mb-0">
                                                                <label class="m-0" for="abilityName">Nume
                                                                    abilitate</label>
                                                                    <input type="text"
                                                                    [(ngModel)]="jobAbilities.abilityName"
                                                                    id="abilityName"
                                                                    name="abilityName"
                                                                    class="form-control">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4 col-6">
                                                            <div class="form-group mb-0">
                                                                <label class="m-0" for="abilityDescription">Descriere
                                                                    abilitate</label>
                                                                <input type="text"
                                                                       id="abilityDescription"
                                                                       name="abilityDescription"
                                                                       [(ngModel)]="jobAbilities.abilityDescription"
                                                                       class="form-control">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 col-6">
                                                            <div class="form-group mb-0">
                                                                <label class="m-0" for="abilityLevel">Nivel</label>
                                                                <select id="abilityLevel"
                                                                        name="abilityLevel"
                                                                        [(ngModel)]="jobAbilities.abilityLevel"
                                                                        class="form-control">
                                                                    <option value="" selected disabled hidden> --
                                                                        Selecteaza
                                                                        optiune --
                                                                    </option>
                                                                    <option value="Baza">Baza</option>
                                                                    <option value="Mediu">Mediu</option>
                                                                    <option value="Avansat">Avansat</option>
                                                                    <option value="Expert">Expert</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-1 col-12 mt-9">
                                                            <button (click)="removeJobAbilities( index )"
                                                                    title="Remove Language"
                                                                    class="remove btn btn-danger">
                                                                X
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-template>
                                            <p class="actions">
                                                <button class="form-control add-language" type="button"
                                                        (click)="addJobAbilities()">
                                                        Mai adauga o abilitate
                                                </button>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Work Experience-->
                    <div id="work-experience" class="mt-10">
                        <div class="row">
                            <div class="col-12">
                                <h5 class="custom-section-title">Experienta de lucru</h5>
                            </div>
                            <div class="col-12">
                                <div class="bg-white p-5">
                                    <div class="row">
                                        <!--Similar Experience Mandatory-->
                                        <div class="col-md-12">
                                            <ng-template ngFor let-userExperienceModel [ngForOf]="form.userExperience"
                                                         let-index="index" ngModelGroup="similarExperience">
                                                <div class="mb-5">
                                                    <div class="row" ngModelGroup="similarExperience_{{index}}">
                                                        <div class="col-md-9 col-6">
                                                            <div class="form-group mb-0">
                                                                <label class="m-0"
                                                                       for="departmentName">Departament</label>
                                                                <select
                                                                        id="departmentName"
                                                                        class="form-control"
                                                                        name="department"
                                                                        [(ngModel)]="userExperienceModel.department"

                                                                        #department="ngModel"
                                                                >
                                                                    <option value="" selected disabled hidden> --
                                                                        Selecteaza
                                                                        optiune --
                                                                    </option>
                                                                    <option *ngFor="let department of departments"
                                                                            value="{{department}}">{{department}}</option>
                                                                </select>

                                                            </div>
                                                        </div>
                                                        <div class="col-md-2 col-6">
                                                            <div class="form-group mb-0">
                                                                <label class="m-0"
                                                                       for="departmentYear">Experienta</label>
                                                                <input
                                                                        type="number"
                                                                        min="0"
                                                                        id="departmentYear"
                                                                        class="form-control"
                                                                        [(ngModel)]="userExperienceModel.year"
                                                                        name="year"

                                                                        #year="ngModel"
                                                                >
                                                            </div>
                                                        </div>
                                                        <div class="col-md-1 col-12 mt-9">
                                                            <button (click)="removeUserExperience( index )"
                                                                    title="Remove Experience"
                                                                    class="remove btn btn-danger">
                                                                X
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-template>
                                            <p class="actions">
                                                <button class="form-control add-language" type="button"
                                                        (click)="addUserExperience()">
                                                        Mai adauga un departament
                                                </button>
                                            </p>
                                        </div>
                                        <!--Legal Work Permission-->
                                        <div class="col-lg-6 col-12">
                                            <div class="form-group">
                                                <div class="job-type-area">
                                                    <label for="legalWorkPermitMandatory" class="d-block c-label">Permis
                                                        legal de munca obligatoriu</label>
                                                    <label for="legalWorkPermitMandatory"
                                                           class="checkbox-container d-inline-block">Da
                                                        <input class="form-check-input"
                                                               type="checkbox"
                                                               id="legalWorkPermitMandatory"
                                                               name="legalWorkPermitMandatory"
                                                               [(ngModel)]="jobAllData.legalWorkPermitMandatory"
                                                        >
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <!--Total Experience-->
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label for="totalExperience">Experienta totala de munca</label>
                                                <input class="form-control"
                                                       type="number"
                                                       min="0"
                                                       id="totalExperience"
                                                       name="totalExperience"
                                                       [(ngModel)]="jobAllData.totalExperience">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Salary-->
                    <div id="salary-info" class="mt-10">
                        <div class="row">
                            <div class="col-12">
                                <h5 class="custom-section-title">Pachet salarial</h5>
                            </div>
                            <div class="col-12">
                                <div class="bg-white p-5">
                                    <div class="row">
                                        <!--Confidential Salary-->
                                        <div class="col-lg-12 col-12">
                                            <div class="form-group">
                                                <div class="job-type-area">
                                                    <label for="confidentialSalaryLevel" class="d-block c-label">Nivel
                                                        salarial confidential</label>
                                                    <label for="confidentialSalaryLevel"
                                                           class="checkbox-container d-inline-block">Da
                                                        <input class="form-check-input"
                                                               type="checkbox"
                                                               id="confidentialSalaryLevel"
                                                               name="confidentialSalaryLevel"
                                                               [(ngModel)]="jobAllData.confidentialSalaryLevel"
                                                               #confidentialSalary="ngModel"
                                                        >
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <!--Minim Salary-->
                                        <div class="col-md-6 col-12" *ngIf="confidentialSalary.value === false">
                                            <div class="job-type-area">
                                                <div class="form-group">
                                                    <label class="m-0" for="minimumSalaryLevel">Nivel
                                                        salarial minim net fix</label>
                                                    <div class="input-group">
                                                        <input
                                                                id="minimumSalaryLevel"
                                                                type="number"
                                                                class="form-control"
                                                                min="0"
                                                                [(ngModel)]="minSal"
                                                                name="minimumSalaryLevel"

                                                                #minimumSalaryLevel="ngModel"
                                                        >
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text currency-box">€/Luna</div>
                                                        </div>
                                                    </div>
                                                    <div class="error-msg" *ngIf="maxSal < minSal">
                                                        Salariul minim nu poate fi mai mare decat salariul maxim.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!--Max Salary-->
                                        <div class="col-md-6 col-12" *ngIf="confidentialSalary.value === false">
                                            <div class="job-type-area">
                                                <div class="form-group">
                                                    <label class="m-0" for="maximumSalaryLevel">Nivel
                                                        salarial maxim net fix</label>
                                                    <div class="input-group">
                                                        <input
                                                                id="maximumSalaryLevel"
                                                                type="number"
                                                                class="form-control"
                                                                min="0"
                                                                [(ngModel)]="maxSal"
                                                                name="maximumSalaryLevel"

                                                                #maximumSalaryLevel="ngModel"
                                                        >
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text currency-box">€/Luna</div>
                                                        </div>
                                                    </div>
                                                    <div class="error-msg" *ngIf="maxSal < minSal">
                                                        Salariul maxim nu poate fi mai mic decat salariul minim.
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <!--Bonus-->
                                        <div class="col-md-6 col-12" *ngIf="confidentialSalary.value === false">
                                            <div class="form-group">
                                                <label class="m-0" for="bonus">Bonus</label>
                                                <select
                                                        id="bonus"
                                                        class="form-control"
                                                        [(ngModel)]="jobAllData.bonus"
                                                        name="bonus"

                                                        #bonus='ngModel'
                                                >
                                                    <option value="" selected disabled hidden> -- Selecteaza optiune --
                                                    </option>
                                                    <option *ngFor="let test of selectBonus"
                                                            value="{{test.valueName}}">{{test.name}}</option>
                                                </select>

                                            </div>
                                        </div>
                                        <!--Average Bonus Value-->
                                        <div class="col-md-6 col-12" *ngIf="confidentialSalary.value === false">
                                            <div class="form-group">
                                                <label class="m-0" for="averageBonusValue">Valoare medie a
                                                    bonusului</label>
                                                <div class="input-group">
                                                    <input id="averageBonusValue"
                                                           type="number"
                                                           class="form-control"
                                                           min="0"
                                                           [(ngModel)]="jobAllData.averageBonusValue"
                                                           name="averageBonusValue"
                                                    >
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text currency-box">€</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!--Other Benefits-->
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label class="m-0" for="otherBenefits">Alte beneficii</label>

                                                <ng-select2
                                                        [data]="selectOtherBenefits"
                                                        [options]="multiOptions"
                                                        [placeholder]="'-- Selecteaza optiune --'"
                                                        [(ngModel)]="jobAllData.otherBenefits"
                                                        id="otherBenefits"
                                                        name="otherBenefits"
                                                        #otherBenefits="ngModel">
                                                </ng-select2>

                                            </div>
                                        </div>
                                        <!--Career Possibility-->
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label class="m-0" for="careerPossibility">Posibilitati de
                                                    cariera</label>

                                                <ng-select2
                                                        [data]="selectCareerPossibility"
                                                        [options]="multiOptions"
                                                        [placeholder]="'-- Selecteaza optiune --'"
                                                        [(ngModel)]="jobAllData.careerPossibility"
                                                        id="careerPossibility"
                                                        name="careerPossibility"
                                                        #careerPossibility="ngModel">
                                                </ng-select2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Work Environment-->
                    <div id="work-environment" class="mt-10">
                        <div class="row">
                            <div class="col-12">
                                <h5 class="custom-section-title">Conditii de lucru</h5>
                            </div>
                            <div class="col-12">
                                <div class="bg-white p-5">
                                    <div class="row">
                                        <!--Work Program-->
                                        <div class="col-md-6 col-12">
                                            <div class="form-group mb-0">
                                                <label class="m-0"
                                                       for="workProgram">Program de lucru</label>
                                                <select
                                                        id="workProgram"
                                                        class="form-control"
                                                        name="workProgram"
                                                        [(ngModel)]="jobAllData.workProgram"
                                                        #workProgram="ngModel"
                                                >
                                                    <option value="" selected disabled hidden> -- Selecteaza
                                                        optiune --
                                                    </option>
                                                    <option *ngFor="let workProg of selectWorkProgram"
                                                            value="{{workProg.valueName}}">{{workProg.name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--Work Space-->
                                        <div class="col-md-6 col-12">
                                            <div class="form-group mb-0">
                                                <label class="m-0" for="workSpace">Spatiu de lucru</label>
                                                <select
                                                        id="workSpace"
                                                        class="form-control"
                                                        name="workSpace"
                                                        [(ngModel)]="jobAllData.workSpace"
                                                        #workSpace="ngModel"
                                                >
                                                    <option value="" selected disabled hidden> -- Selecteaza
                                                        optiune --
                                                    </option>
                                                    <option *ngFor="let workSpace of selectWorkSpace"
                                                            value="{{workSpace.valueName}}">{{workSpace.name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--Physical Effort-->
                                        <div class="col-md-6 col-12" *ngIf="jobAllData.physicalEffortRequired !== null">
                                            <div class="form-group mb-0">
                                                <label class="m-0"
                                                       for="physicalEffortRequiredType">Efort fizic</label>
                                                <select
                                                        id="physicalEffortRequiredType"
                                                        class="form-control"
                                                        name="physicalEffortRequiredType"
                                                        [(ngModel)]="jobAllData.physicalEffortRequired.type"
                                                        #physicalType="ngModel"
                                                >
                                                    <option value="" selected disabled hidden> -- Selecteaza
                                                        optiune --
                                                    </option>
                                                    <option value="Normal">Normal</option>
                                                    <option value="Suplimentar">Suplimentar</option>
                                                    <option value="Specifice">Specifice</option>
                                                </select>
                                            </div>
                                        </div>

                                         <!--Disponibilitate ridicare greutati -->
                                    <div class="col-md-6 col-12">
                                        <div class="form-group mb-0"><label class="m-0" for="weightLiftingRequired">Disponibilitate ridicare greutati</label> <select id="weightLiftingRequired" class="form-control" name="weightLiftingRequired"
                                                                  ngModel #weightLiftingRequired="ngModel">
                                            <option value="" selected disabled hidden> -- Selecteaza optiune --</option>
                                            <option *ngFor="let weightLiftingRequired of selectWeightLiftingRequired"
                                                    value="{{weightLiftingRequired.valueName}}">{{weightLiftingRequired.name}}</option>
                                        </select></div>
                                    </div>

                                    <!--Expunere temperaturi -->
                                    <div class="col-md-6 col-12">
                                        <div class="form-group mb-0"><label class="m-0" for="workTemperature">De acord sa lucrezi la diferite temperaturi:</label> <select id="workTemperature" class="form-control" name="workTemperature"
                                                                  ngModel #workTemperature="ngModel">
                                            <option value="" selected disabled hidden> -- Selecteaza optiune --</option>
                                            <option *ngFor="let workTemperature of selectWorkTemperature"
                                                    value="{{workTemperature.valueName}}">{{workTemperature.name}}</option>
                                        </select></div>
                                    </div>

                                        <!--Physical Effort Details-->
                                        <div class="col-md-6 col-12" *ngIf="jobAllData.physicalEffortRequired !== null">
                                            <div class="form-group mb-0">
                                                <label class="m-0" for="physicalDetails">Detalii</label>
                                                <input
                                                        type="text"
                                                        id="physicalDetails"
                                                        class="form-control"
                                                        placeholder="TXT(KG,TEMPERATURI, ETC)"
                                                        [(ngModel)]="jobAllData.physicalEffortRequired.detail"
                                                        name="physicalDetails"
                                                        #physicalDetails="ngModel"
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Mini Interview-->
                    <div id="mini-interview" class="mt-10">
                        <div class="row">
                            <div class="col-12">
                                <h5 class="custom-section-title">Mini interviu</h5>
                            </div>


                            <div class="col-12">
                                <div class="bg-white p-5">
                                    <div class="row">

                                        <div class="col-12">
                                            <div class="alert alert-warning " role="alert">
                                                <h4 class="text-white mb-0 font-weight-bold">Intrebarile din mini
                                                    interviu
                                                    nu mai pot fi modificate dupa postare!</h4>
                                            </div>
                                        </div>

                                        <!--Question 1-->
                                        <div class="col-12" ngModelGroup="miniInterview">
                                            <div class="form-group">
                                                <label class="m-0">Intrebarea 1</label>
                                                <h4 class="green-color">{{jobAllData.miniInterview.question1}}</h4>
                                            </div>
                                        </div>
                                        <!--Question 2-->
                                        <div class="col-12" ngModelGroup="miniInterview">
                                            <div class="form-group">
                                                <label class="m-0">Intrebarea 2</label>
                                                <h4 class="green-color">{{jobAllData.miniInterview.question2}}</h4>
                                            </div>
                                        </div>
                                        <!--Question 3-->
                                        <div class="col-12" ngModelGroup="miniInterview">
                                            <div class="form-group">
                                                <label class="m-0">Intrebarea 3</label>
                                                <h4 class="green-color">{{jobAllData.miniInterview.question3}}</h4>
                                            </div>
                                        </div>
                                        <!--Question 4-->
                                        <div class="col-12" ngModelGroup="miniInterview">
                                            <div class="form-group">
                                                <label class="m-0">Intrebarea 4</label>
                                                <h4 class="green-color">{{jobAllData.miniInterview.question4}}</h4>
                                            </div>
                                        </div>
                                        <!--Question 5-->
                                        <div class="col-12" ngModelGroup="miniInterview">
                                            <div class="form-group">
                                                <label class="m-0">Intrebarea 5</label>
                                                <h4 class="green-color">{{jobAllData.miniInterview.question5}}</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Submit Button-->
                    <div class="text-center">
                        <button
                                type="submit"
                                class="green-button w-100 d-block border-0"
                        >
                            Actualizeaza job
                        </button>
                    </div>
                </div>

            </form>
            <!--Form End-->
        </div>
    </div>
</div>
<!--Footer-->
<app-footer></app-footer>
